module.exports = __webpack_public_path__ + "static/img/service_passprime_center.cc368d16.svg";